import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reabilitacao',
  templateUrl: './reabilitacao.component.html',
  styleUrls: ['./reabilitacao.component.scss']
})
export class ReabilitacaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
